import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "p-4 bg-white shadow-md rounded" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 rounded-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen text-gray-400" }, null, -1)
const _hoisted_5 = {
  type: "file",
  name: "profile_avatar",
  ref: "fileInput",
  class: "hidden"
}

import { ref, watch, PropType } from "vue";
import { useDropzone } from "vue3-dropzone";
import ApiService from "@/_services/api.service";
import { IVignette } from "@/models/vignette/interface/IVignette";
const maxSizeAllowed = 2000000;
const wrongFormatErrorMsg =
    "Le format de fichier doit être en JPG, PNG ou SVG.";
const tooLargeFileErrorMsg =
    "Le fichier est trop volumineux. Sa taille ne doit pas dépasser 2 Mo.";
const globalErrorMsg = "Désolé, il y a eu un problème au téléchargement de l'image. Veuillez réessayer. 5";

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadImage',
  props: {
    imagePreviewUrl: {
        type: null as unknown as PropType<string | null>,
    },
    acceptedExtensions:{
        type: Array,
    },
},
  emits: ["imageUploaded", "imageRemoved", "error"],
  setup(__props, { emit }) {

const props = __props;


const imagePreviewUrl = ref(props.imagePreviewUrl);
const acceptedExtensions =  props.acceptedExtensions?.length ? props.acceptedExtensions: [".jpg", ".jpeg", ".svg", ".png"];
const acceptedMimeTypes = [
    "image/jpg",
    "image/jpeg",
    "image/svg+xml",
    "image/png",
];
const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxSize: maxSizeAllowed,
    accept: acceptedExtensions.join(", "),
    onDropRejected: (rejectReasons: object) => {
        let errorCode = rejectReasons[0].errors[0].code;
        if (errorCode === "file-too-large") {
            emit("error", tooLargeFileErrorMsg);
            return;
        }
        if (errorCode === "file-invalid-type") {
            emit("error", wrongFormatErrorMsg);
            return;
        }
        emit("error", globalErrorMsg);
    },
});


const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && !acceptedMimeTypes.includes(file.type)) {
        emit("error", wrongFormatErrorMsg);
    }
    if (file && acceptedMimeTypes.includes(file.type)) {
        onDrop(e.target.files);
    }
};
async function onDrop(acceptFiles) {
    try {
        if (acceptFiles.length > 0 && acceptFiles instanceof FileList) {
            let fileToSave = acceptFiles[0];
            if (fileToSave.size > maxSizeAllowed) {
                emit("error", tooLargeFileErrorMsg);
            } else {
                let file = new FormData();
                file.append("file", fileToSave);
                await ApiService.post("images", file).then((response) => {
                    imagePreviewUrl.value = response.data.data.url;
                    emit("imageUploaded", response.data.data);
                });
            }
        }
    } catch (error) {
        emit("error", globalErrorMsg);
    }
}

watch(
    () => props.imagePreviewUrl,
    (newValue) => {
        if (newValue !== undefined && newValue !== null) {
            imagePreviewUrl.value = newValue as string;
        } else {
            imagePreviewUrl.value = "../../assets/img/blank2.png";
        }
    }
);
const removeImage = () => {
    imagePreviewUrl.value = "../../assets/img/blank2.png";
    emit("imageRemoved", null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _mergeProps({ class: "relative p-2 border rounded" }, _unref(getRootProps)()), [
      (imagePreviewUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "w-full h-auto rounded",
            src: imagePreviewUrl.value,
            alt: "Uploaded image"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("input", _mergeProps(_unref(getInputProps)(), {
          type: "file",
          name: "profile_avatar",
          onChange: handleImageChange,
          class: "hidden"
        }), null, 16)
      ]),
      (imagePreviewUrl.value !== 'media/avatars/blank2.png')
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "absolute top-8 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 border border-red-600 rounded text-white fas fa-trash-alt",
            onClick: removeImage
          }, [
            _createElementVNode("input", _hoisted_5, null, 512)
          ]))
        : _createCommentVNode("", true)
    ], 16)
  ]))
}
}

})